module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-MediumItalic-c89d9b45b3a6df31dbc58d2eaf5ae322.otf";